module.exports = __webpack_public_path__ + "img/ml3082.2c44fad4.png";